// Mock data for LaundryBnB application

export const mockLinenTypes = [
  { id: 'king-flat', name: 'King Flat Sheet', category: 'sheets' },
  { id: 'queen-flat', name: 'Queen Flat Sheet', category: 'sheets' },
  { id: 'king-fitted', name: 'King Fitted Sheet', category: 'sheets' },
  { id: 'queen-fitted', name: 'Queen Fitted Sheet', category: 'sheets' },
  { id: 'king-duvet', name: 'King Duvet Cover', category: 'bedding' },
  { id: 'queen-duvet', name: 'Queen Duvet Cover', category: 'bedding' },
  { id: 'pillowcase', name: 'Pillowcase', category: 'bedding' },
  { id: 'bath-towel', name: 'Bath Towel', category: 'towels' },
  { id: 'hand-towel', name: 'Hand Towel', category: 'towels' }
];

export const mockPricingConfig = {
  'king-flat': { cost: 28, rentalPrice: 9.33, launderingPrice: 4.50 },
  'queen-flat': { cost: 25, rentalPrice: 8.33, launderingPrice: 4.00 },
  'king-fitted': { cost: 30, rentalPrice: 10.00, launderingPrice: 4.50 },
  'queen-fitted': { cost: 27, rentalPrice: 9.00, launderingPrice: 4.00 },
  'king-duvet': { cost: 45, rentalPrice: 15.00, launderingPrice: 5.50 },
  'queen-duvet': { cost: 42, rentalPrice: 14.00, launderingPrice: 5.00 },
  'pillowcase': { cost: 12, rentalPrice: 4.00, launderingPrice: 2.00 },
  'bath-towel': { cost: 18, rentalPrice: 6.00, launderingPrice: 3.00 },
  'hand-towel': { cost: 12, rentalPrice: 4.00, launderingPrice: 2.50 }
};

export const mockDeliveryCharges = {
  pickup: 25.00,
  delivery: 25.00
};

export const mockProperties = [
  {
    id: '1',
    address: '123 N Michigan Ave, Chicago, IL 60611',
    coordinates: { lat: 41.8781, lng: -87.6298 },
    items: {
      'king-flat': 4,
      'king-fitted': 4,
      'king-duvet': 2,
      'pillowcase': 8,
      'bath-towel': 6,
      'hand-towel': 4
    },
    createdAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '2',
    address: '456 W Fullerton Pkwy, Chicago, IL 60614',
    coordinates: { lat: 41.9250, lng: -87.6500 },
    items: {
      'queen-flat': 6,
      'queen-fitted': 6,
      'queen-duvet': 3,
      'pillowcase': 12,
      'bath-towel': 8,
      'hand-towel': 6
    },
    createdAt: '2024-01-16T14:20:00Z'
  }
];

export const mockAdminSettings = {
  companyName: 'LaundryBnB',
  parentCompany: 'Washmii',
  defaultMarkup: 0.15, // 15% markup
  serviceFee: 5.00,
  taxRate: 0.08 // 8% tax
};

// Helper functions for mock data
export const calculateMonthlyRental = (cost, months = 3) => {
  return Math.round((cost / months) * 100) / 100; // Cost recovered in specified months
};

export const generateQuote = (properties, pricingConfig = mockPricingConfig, linenTypes = mockLinenTypes) => {
  let totalMonthlyRental = 0;
  let totalLaunderingPerVisit = 0;
  let itemBreakdown = [];

  properties.forEach(property => {
    Object.entries(property.items).forEach(([itemId, quantity]) => {
      const pricing = pricingConfig[itemId];
      const item = linenTypes.find(item => item.id === itemId);
      
      if (pricing && item) {
        const monthlyRental = pricing.rentalPrice * quantity;
        const launderingCost = pricing.launderingPrice * quantity;
        
        totalMonthlyRental += monthlyRental;
        totalLaunderingPerVisit += launderingCost;
        
        itemBreakdown.push({
          address: property.address,
          itemName: item.name,
          quantity,
          unitRentalPrice: pricing.rentalPrice,
          totalRentalPrice: monthlyRental,
          unitLaunderingPrice: pricing.launderingPrice,
          totalLaunderingPrice: launderingCost
        });
      }
    });
  });

  const deliveryCharges = mockDeliveryCharges.pickup + mockDeliveryCharges.delivery;
  
  return {
    monthlyRental: totalMonthlyRental,
    launderingPerVisit: totalLaunderingPerVisit,
    deliveryChargesPerVisit: deliveryCharges,
    itemBreakdown,
    totalPropertiesCount: properties.length,
    generatedAt: new Date().toISOString()
  };
};